// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__1CAIQ","actionColumn":"ReferralSources_actionColumn__z18x2","textButton":"ReferralSources_textButton__2LJSP"};